import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

import type { IOrderFormJson } from '../types/order-form-json.type'

export type TOrderFormProductService = {
  payload: {
    jsonOrderForm: IOrderFormJson
    arrayOfProducts: string
    filter: string
  }
}

export const orderFormProductService = async ({
  payload,
}: TOrderFormProductService): Promise<ResponseAPI> => {
  const response = await api.post(
    `produto/${payload.filter}/${payload.arrayOfProducts}`,
    payload.jsonOrderForm,
  )

  return response.data
}
